module.exports = __webpack_public_path__ + "img/cxTrends-2.447bf4e9.png";